module.exports = __webpack_public_path__ + "static/media/iep-wire01.6db11b97.jpg";